import React from 'react'
import govindh from '../../pages/about/ee/govind.png'
import Hero from './Hero'
import About from './About'
function Govindh () {
  return (
    <section className="container-fluid p-0">
        <Hero title="Govind Raj J" subtitle="Govind is a highly creative video editor with an exceptional talent for transforming ordinary footage into extraordinary content through his innovative ideas and unique editing styles. With a mechanical background, he discovered his passion for filmmaking and honed his skills in presenting diverse content creatively, tailored to various fields. His ability to bring fresh perspectives and artistic enhancements makes him a valuable asset to any project. Whether on set or in the editing room, Govind’s expertise consistently elevates the quality and impact of the final product." image={govindh}/>
        </section>
  )
}

export default Govindh 